import React from 'react';

export function PreSignupViewer(props) {
  const data = require('../../../assets/lang/components/preSignup.json');
  const {
    formValues,
    onFieldChange,
    onSubmit,
    isSubmitted,
    isSubmitting,
    submitError,
  } = props;

  return (
    <section className="pre-signup">
      <div className="pre-signup__inner">
        <div className="pre-signup__hero">
          <p className="pre-signup__eyebrow">{data.hero.eyebrow}</p>
          <h1>{data.hero.title}</h1>
          <p className="pre-signup__lede">{data.hero.lede}</p>
        </div>

        <div className="pre-signup__content">
          <div className="pre-signup__panel">
            <h2>{data.benefits.title}</h2>
            <ul className="pre-signup__benefits">
              {data.benefits.items.map((item) => (
                <li key={item}>{item}</li>
              ))}
            </ul>
          </div>

          <div className="pre-signup__panel pre-signup__panel--form">
            <h2>{data.form.title}</h2>
            {!isSubmitted && <form className="pre-signup__form" onSubmit={onSubmit}>
              <div className="pre-signup__field">
                <label htmlFor="full_name">{data.form.labels.full_name}</label>
                <input
                  id="full_name"
                  name="full_name"
                  type="text"
                  required
                  disabled={isSubmitting}
                  value={formValues.full_name}
                  onChange={onFieldChange}
                  placeholder={data.form.placeholders.full_name}
                />
              </div>

              <div className="pre-signup__field">
                <label htmlFor="work_email">{data.form.labels.work_email}</label>
                <input
                  id="work_email"
                  name="work_email"
                  type="email"
                  required
                  disabled={isSubmitting}
                  value={formValues.work_email}
                  onChange={onFieldChange}
                  placeholder={data.form.placeholders.work_email}
                />
              </div>

              <div className="pre-signup__field">
                <label htmlFor="company_name">{data.form.labels.company_name}</label>
                <input
                  id="company_name"
                  name="company_name"
                  type="text"
                  required
                  disabled={isSubmitting}
                  value={formValues.company_name}
                  onChange={onFieldChange}
                  placeholder={data.form.placeholders.company_name}
                />
              </div>

              <div className="pre-signup__field">
                <label htmlFor="team_size">{data.form.labels.team_size}</label>
                <input
                  id="team_size"
                  name="team_size"
                  type="text"
                  required
                  disabled={isSubmitting}
                  value={formValues.team_size}
                  onChange={onFieldChange}
                  placeholder={data.form.placeholders.team_size}
                />
              </div>

              <div className="pre-signup__field">
                <label htmlFor="ai_interest">{data.form.labels.ai_interest}</label>
                <textarea
                  id="ai_interest"
                  name="ai_interest"
                  required
                  disabled={isSubmitting}
                  value={formValues.ai_interest}
                  onChange={onFieldChange}
                  placeholder={data.form.placeholders.ai_interest}
                />
              </div>

              <button className="pre-signup__submit" type="submit" disabled={isSubmitting}>
                {isSubmitting ? data.form.submitting : data.form.submit}
              </button>
            </form>}

            {!isSubmitted && submitError && <p className="pre-signup__error">{submitError}</p>}

            {isSubmitted && <div className="pre-signup__success">
              <h3>{data.success.title}</h3>
              <p>{data.success.body}</p>
            </div>}
          </div>
        </div>
      </div>
    </section>
  );
}
